/* ============================================================================
   Furniva product page behaviour.

   Everything here is an enhancement over markup that already works:
     - variant options are real links, so a finish is shareable and selectable
       without JavaScript;
     - Add to cart is a real product form;
     - the gallery's thumbnails degrade to links to the full image.
   ============================================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-fv-product]');
  if (!root) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }
  function $$(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }
  function on(el, type, handler, options) {
    if (el) el.addEventListener(type, handler, options);
  }
  function hapticSuccess() {
    if ('vibrate' in navigator) navigator.vibrate(18);
  }

  /* --------------------------------------------------------------------------
     Quantity stepper.
     -------------------------------------------------------------------------- */
  $$('[data-fv-qty]').forEach(function (stepper) {
    var input = $('input', stepper);
    if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10) || 1;

    function nudge(delta) {
      var value = parseInt(input.value, 10);
      if (isNaN(value)) value = min;
      value += delta;
      if (value < min) value = min;
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    on($('[data-fv-qty-down]', stepper), 'click', function () {
      nudge(-1);
    });
    on($('[data-fv-qty-up]', stepper), 'click', function () {
      nudge(1);
    });
  });

  /* --------------------------------------------------------------------------
     Gallery — thumbnails drive the hero, and the label follows the image so the
     pill never describes a shot that is no longer on screen.
     -------------------------------------------------------------------------- */
  (function gallery() {
    var main = $('.fv-gal__main');
    var hero = $('.fv-gal__hero');
    var label = $('[data-fv-gallery-label]');
    var thumbs = $$('[data-fv-gallery-thumb]');
    if (!main || !hero || !thumbs.length) return;

    /* Videos live in the hero alongside the still, one shown at a time.

       Switching away pauses whatever was playing — a video left running behind
       a photograph is a sound coming from nowhere. An embedded YouTube or Vimeo
       player cannot be paused from here without its own API, so that one is
       torn out of the document and put back, which stops it in every browser
       and costs nothing since it is only built when it is shown. */
    var videos = $$('[data-fv-gal-video]');

    function stopVideos() {
      videos.forEach(function (box) {
        if (box.hidden) return;
        var native = box.querySelector('video');
        if (native && typeof native.pause === 'function') native.pause();
        var frame = box.querySelector('iframe');
        if (frame) {
          var src = frame.getAttribute('src');
          frame.setAttribute('src', src);
        }
        box.hidden = true;
      });
    }

    function showVideo(id) {
      var wanted = null;
      videos.forEach(function (box) {
        if (box.dataset.fvGalVideo === id) wanted = box;
      });
      stopVideos();
      if (!wanted) return false;
      wanted.hidden = false;
      return true;
    }

    /* On a laptop the hero is the main photograph and stays so: the grid
       below holds the rest, and the hero or a tile opens the viewer at that
       shot, stepping through them all in order. The viewer's own delegated
       handler does the opening; these attributes are what it looks for, and
       they are only present at laptop width so a phone's thumbnail tap still
       just moves the slider. A video tile plays in the hero instead. */
    var wide = window.matchMedia('(min-width: 1024px)');
    function syncViewer() {
      var shots = [hero].concat(thumbs.filter(function (t) {
        return !t.hasAttribute('data-fv-hero-thumb') && !t.dataset.fvVideo;
      }));
      shots.forEach(function (el) {
        var live = wide.matches && !(el === hero && hero.classList.contains('is-playing'));
        if (live) {
          el.setAttribute('data-fv-zoom-open', '');
          el.setAttribute('data-fv-zoom-group', 'gallery');
        } else {
          el.removeAttribute('data-fv-zoom-open');
          el.removeAttribute('data-fv-zoom-group');
        }
      });
    }
    syncViewer();
    if (wide.addEventListener) wide.addEventListener('change', syncViewer);

    thumbs.forEach(function (thumb) {
      on(thumb, 'click', function () {
        // On a phone the slider shows the shot (phoneSlider below); loading
        // it into the hidden laptop hero as well would only cost data.
        var phoneTrack = $('[data-fv-gal-track]');
        if (phoneTrack && phoneTrack.offsetParent !== null) {
          thumbs.forEach(function (other) { other.setAttribute('aria-current', 'false'); });
          thumb.setAttribute('aria-current', 'true');
          return;
        }

        var videoId = thumb.dataset.fvVideo;
        if (videoId && showVideo(videoId)) {
          // The hero's own controls have nothing to say about a video: there is
          // no magnifying a moving picture, and the pill would sit over it.
          hero.classList.add('is-playing');
          if (label) label.hidden = true;
          syncViewer();
          return;
        }
        stopVideos();
        hero.classList.remove('is-playing');
        if (label) label.hidden = label.textContent.trim() === '';
        syncViewer();
        // A photograph tile at laptop width opens the viewer (above); the
        // hero keeps the main shot.
        if (wide.matches) return;
        thumbs.forEach(function (other) { other.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');

        var full = thumb.dataset.fvFull;
        var alt = thumb.dataset.fvAlt || '';
        // The visible chip and the accessible description are two different
        // strings: printing the alt text here is what ran a long product title
        // across the image. A shot with no short label gets no chip at all.
        var viewLabel = thumb.dataset.fvViewLabel || '';
        if (!full) return;
        main.classList.add('is-changing');
        main.src = full;
        main.removeAttribute('srcset');
        main.alt = alt;
        var settle = function () { main.classList.remove('is-changing'); };
        if (main.complete) window.requestAnimationFrame(settle);
        else on(main, 'load', settle, { once: true });
        if (label) {
          label.textContent = viewLabel;
          label.hidden = viewLabel === '';
        }
      });
    });

    /* A single finger now drives the main photograph itself. Vertical movement
       remains page scrolling; a deliberate horizontal drag follows the finger
       and settles on the adjacent image when released. Two fingers remain
       reserved for the pinch-to-inspect interaction below. */
    var swipeStart = null;
    var swipeDelta = 0;
    var swipeAxis = null;

    function clearSwipe() {
      swipeStart = null;
      swipeDelta = 0;
      swipeAxis = null;
      main.style.transition = '';
      main.style.transform = '';
      main.style.opacity = '';
    }

    function stepGallery(direction) {
      var active = thumbs.findIndex(function (thumb) {
        return thumb.getAttribute('aria-current') === 'true';
      });
      if (active < 0) active = 0;
      var next = active + direction;
      if (next < 0 || next >= thumbs.length) return;
      thumbs[next].click();
      if (typeof thumbs[next].scrollIntoView === 'function') {
        thumbs[next].scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    hero.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1 || hero.classList.contains('is-playing')) {
        clearSwipe();
        return;
      }
      swipeStart = {
        x: event.touches[0].clientX,
        y: event.touches[0].clientY
      };
      swipeAxis = null;
    }, { passive: true });

    hero.addEventListener('touchmove', function (event) {
      if (!swipeStart || event.touches.length !== 1) return;
      var dx = event.touches[0].clientX - swipeStart.x;
      var dy = event.touches[0].clientY - swipeStart.y;
      if (!swipeAxis) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
        swipeAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
      if (swipeAxis !== 'x') return;
      event.preventDefault();
      swipeDelta = dx;
      main.style.transition = 'none';
      main.style.transform = 'translate3d(' + Math.max(-70, Math.min(70, dx * 0.38)) + 'px,0,0)';
      main.style.opacity = String(Math.max(0.72, 1 - Math.abs(dx) / 360));
    }, { passive: false });

    hero.addEventListener('touchend', function () {
      var delta = swipeDelta;
      clearSwipe();
      if (Math.abs(delta) < 44) return;
      stepGallery(delta < 0 ? 1 : -1);
    }, { passive: true });

    hero.addEventListener('touchcancel', clearSwipe, { passive: true });
  })();

  /* --------------------------------------------------------------------------
     Phone slider — the track the finger drags below 1024px.

     The track scrolls natively (scroll snap), so the motion itself is the
     browser's. This only keeps the rest in step: the thumbnail strip marks
     the shot in view, the counter reads "2 / 6", a thumbnail tap glides the
     track there, and every shot is fetched once the first is up, so a swipe
     never lands on an empty square.
     -------------------------------------------------------------------------- */
  (function phoneSlider() {
    var track = $('[data-fv-gal-track]');
    if (!track) return;
    var slides = $$('[data-fv-gal-slide]', track);
    var thumbs = $$('[data-fv-gallery-thumb]');
    var count = $('[data-fv-gal-count]');
    if (slides.length < 2) return;
    var current = 0;
    var ticking = false;

    function visible() { return track.offsetParent !== null; }

    function mark(index) {
      if (index === current) return;
      var old = slides[current] && slides[current].querySelector('video');
      if (old && typeof old.pause === 'function') old.pause();
      current = index;
      slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (thumb, i) { thumb.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      if (count) count.textContent = (index + 1) + ' / ' + slides.length;
      var thumb = thumbs[index];
      var strip = thumb && thumb.parentElement;
      if (strip && strip.scrollWidth > strip.clientWidth) {
        strip.scrollTo({ left: thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }
    }
    slides[0].classList.add('is-active');

    /* While a thumbnail tap glides the track several shots along, the shots
       it passes are not "in view": marking each one lit the thumbnails up one
       after another (owner, 2026-10-10). The tapped one is marked at once and
       the scroll only takes over again when it lands. */
    var jumpTo = null;
    var jumpTimer = null;

    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var width = track.clientWidth || 1;
        var index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
        if (jumpTo !== null) {
          if (index === jumpTo) jumpTo = null;
          return;
        }
        mark(index);
      });
    }, { passive: true });

    /* Each shot shimmers while it loads and fades in when it arrives, as
       the photographs on a product tile do. */
    slides.forEach(function (slide) {
      var img = slide.querySelector('img');
      if (!img) return;
      function ready() {
        slide.classList.remove('is-photo-loading');
        img.classList.add('is-photo-ready');
      }
      if (img.complete && img.naturalWidth) return;
      slide.classList.add('is-photo-loading');
      img.addEventListener('load', ready, { once: true });
      img.addEventListener('error', function () { slide.classList.remove('is-photo-loading'); }, { once: true });
    });

    /* Double tap to zoom. The photograph grows 2.5x around the point tapped,
       inside its own square; while it is enlarged one finger moves it (the
       track is held still so the drag does not change the shot), and another
       double tap, a thumbnail or a pinch lets it go. The browser's own
       double-tap page zoom is off on the track (CSS), so it never fights
       this. */
    var ZOOM = 2.5;
    // Phones only: a tablet or a laptop gets no magnifier, just the viewer.
    var phoneWidth = window.matchMedia('(max-width: 759.98px)');
    var zoomed = null;
    var tapAt = 0, tapX = 0, tapY = 0;
    var touchX = 0, touchY = 0, moved = false, panX = 0, panY = 0;

    function paintZoom(animate) {
      var img = zoomed.img;
      img.style.transition = animate && !reduceMotion.matches ? 'transform 280ms cubic-bezier(0.22, 1, 0.36, 1)' : 'none';
      img.style.transform = 'translate3d(' + zoomed.tx + 'px,' + zoomed.ty + 'px,0) scale(' + ZOOM + ')';
    }
    function clamp() {
      var w = zoomed.slide.clientWidth, h = zoomed.slide.clientHeight;
      zoomed.tx = Math.min(0, Math.max(w * (1 - ZOOM), zoomed.tx));
      zoomed.ty = Math.min(0, Math.max(h * (1 - ZOOM), zoomed.ty));
    }
    function zoomIn(slide, x, y) {
      var img = slide.querySelector('img');
      if (!img) return;
      var box = slide.getBoundingClientRect();
      var px = x - box.left, py = y - box.top;
      zoomed = { slide: slide, img: img, tx: px * (1 - ZOOM), ty: py * (1 - ZOOM) };
      clamp();
      slide.classList.add('is-zoomed');
      track.style.overflowX = 'hidden';
      paintZoom(true);
    }
    function zoomOut() {
      if (!zoomed) return;
      var gone = zoomed;
      zoomed = null;
      gone.img.style.transition = reduceMotion.matches ? 'none' : 'transform 240ms ease';
      gone.img.style.transform = '';
      gone.slide.classList.remove('is-zoomed');
      track.style.overflowX = '';
    }

    track.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) { zoomOut(); return; }
      touchX = panX = event.touches[0].clientX;
      touchY = panY = event.touches[0].clientY;
      moved = false;
    }, { passive: true });

    track.addEventListener('touchmove', function (event) {
      if (event.touches.length !== 1) return;
      var x = event.touches[0].clientX, y = event.touches[0].clientY;
      if (Math.abs(x - touchX) > 10 || Math.abs(y - touchY) > 10) moved = true;
      if (!zoomed) return;
      event.preventDefault();
      zoomed.tx += x - panX;
      zoomed.ty += y - panY;
      panX = x;
      panY = y;
      clamp();
      paintZoom(false);
    }, { passive: false });

    track.addEventListener('touchend', function (event) {
      if (moved || event.touches.length) return;
      var slide = event.target.closest && event.target.closest('[data-fv-gal-slide]');
      if (!slide || !slide.querySelector('img')) return;
      var now = Date.now();
      var t = event.changedTouches[0];
      var twice = now - tapAt < 320 && Math.abs(t.clientX - tapX) < 30 && Math.abs(t.clientY - tapY) < 30;
      tapAt = twice ? 0 : now;
      tapX = t.clientX;
      tapY = t.clientY;
      if (!twice) return;
      if (!zoomed && !phoneWidth.matches) return;
      event.preventDefault();
      if (zoomed) zoomOut();
      else zoomIn(slide, t.clientX, t.clientY);
    }, { passive: false });

    // A thumbnail glides the track to its shot. The gallery's own handler
    // still runs (it keeps the laptop hero in step); on a phone the hero is
    // not shown, so only the track moves.
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        if (!visible() || !slides[i]) return;
        zoomOut();
        jumpTo = i;
        mark(i);
        window.clearTimeout(jumpTimer);
        jumpTimer = window.setTimeout(function () { jumpTo = null; }, 1200);
        track.scrollTo({ left: slides[i].offsetLeft, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      });
    });

    function warm() {
      slides.forEach(function (slide) {
        var img = slide.querySelector('img[loading="lazy"]');
        if (img) img.loading = 'eager';
      });
    }
    var first = slides[0].querySelector('img');
    if (first && !first.complete) first.addEventListener('load', warm, { once: true });
    else warm();

    // The zoom opens the shot in view, not the laptop hero's.
    window.FurnivaGallery = window.FurnivaGallery || {};
    window.FurnivaGallery.activeImage = function () {
      if (!visible()) return null;
      return slides[current] && slides[current].querySelector('img');
    };
  })();

  /* --------------------------------------------------------------------------
     Dialogs — zoom and offers.
     -------------------------------------------------------------------------- */
  var FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function focusableIn(container) {
    return Array.prototype.slice.call(container.querySelectorAll(FOCUSABLE)).filter(function (el) {
      // Skip anything not actually rendered — a scrim or a hidden panel would
      // otherwise become a dead stop in the tab cycle.
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }

  function makeDialog(rootSelector, openSelector, closeSelectors, beforeOpen) {
    var dialog = $(rootSelector);
    if (!dialog) return;
    var lastFocus = null;
    var previousOverflow = '';
    var isOpen = false;

    function onKeydown(event) {
      if (dialog.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'Tab') return;

      // A real trap: Tab and Shift+Tab cycle inside the dialog and never reach
      // the page behind it.
      var items = focusableIn(dialog);
      if (!items.length) {
        event.preventDefault();
        return;
      }
      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;

      if (!dialog.contains(active)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus({ preventScroll: true });
        return;
      }
      if (event.shiftKey && active === first) {
        event.preventDefault();
        last.focus({ preventScroll: true });
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus({ preventScroll: true });
      }
    }

    function open(trigger) {
      if (beforeOpen) beforeOpen(trigger);
      isOpen = true;
      lastFocus = trigger || document.activeElement;
      dialog.hidden = false;
      window.requestAnimationFrame(function () {
        if (isOpen) dialog.classList.add('is-open');
      });

      // Remember what the page had rather than assuming '', so closing one
      // dialog cannot clear a lock another surface still needs.
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      var items = focusableIn(dialog);
      if (items.length) items[0].focus({ preventScroll: true });

      document.addEventListener('keydown', onKeydown, true);
    }

    function close() {
      isOpen = false;
      dialog.classList.remove('is-open');
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', onKeydown, true);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      if (reduceMotion.matches) dialog.hidden = true;
      else window.setTimeout(function () {
        if (!dialog.classList.contains('is-open')) dialog.hidden = true;
      }, 420);
    }

    // Delegated, so a control drawn after load (the live offer cards) opens
    // the dialog too.
    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest(openSelector);
      if (button) open(button);
    });
    closeSelectors.forEach(function (selector) {
      $$(selector).forEach(function (button) {
        on(button, 'click', close);
      });
    });
  }

  /* --------------------------------------------------------------------------
     The lightbox.

     Every trigger carries its own full-size source, its alt text and, where it
     has one, a caption. A trigger that names a group — data-fv-zoom-group — can
     be stepped through with the arrows and the keyboard; a lone one shows no
     arrows at all rather than two dead controls.
     -------------------------------------------------------------------------- */
  (function lightbox() {
    var box = $('[data-fv-zoom]');
    if (!box) return;
    var image = $('[data-fv-zoom-image]', box);
    var caption = $('[data-fv-zoom-caption]', box);
    var prev = $('[data-fv-zoom-prev]', box);
    var next = $('[data-fv-zoom-next]', box);
    var group = [];
    var index = 0;

    function sourceOf(trigger) {
      var source = trigger && trigger.dataset.fvFull;
      var alt = (trigger && trigger.dataset.fvAlt) || '';
      // The gallery's Zoom control carries no source of its own: whatever the
      // hero is showing at the moment it is pressed is the shot to open.
      if (!source) {
        var slideImg = window.FurnivaGallery && window.FurnivaGallery.activeImage && window.FurnivaGallery.activeImage();
        var main = slideImg || $('.fv-gal__main');
        if (main) {
          source = main.currentSrc || main.src;
          alt = main.alt;
        }
      }
      return { source: source || '', alt: alt, caption: (trigger && trigger.dataset.fvCaption) || '' };
    }

    function paint(trigger) {
      var shot = sourceOf(trigger);
      image.src = shot.source;
      image.alt = shot.alt;
      if (caption) {
        caption.textContent = shot.caption;
        caption.hidden = shot.caption === '';
      }
    }

    function step(delta) {
      if (group.length < 2) return;
      index = (index + delta + group.length) % group.length;
      paint(group[index]);
    }

    makeDialog(
      '[data-fv-zoom]',
      '[data-fv-zoom-open]',
      ['[data-fv-zoom-close]', '[data-fv-zoom-scrim]'],
      function (trigger) {
        var name = trigger && trigger.dataset.fvZoomGroup;
        group = name ? $$('[data-fv-zoom-open][data-fv-zoom-group="' + name + '"]') : [];
        index = Math.max(0, group.indexOf(trigger));
        var many = group.length > 1;
        if (prev) prev.hidden = !many;
        if (next) next.hidden = !many;
        paint(trigger);
      }
    );

    /* Some triggers are anchors to the full-size file, so the photograph still
       opens with JavaScript off. With the lightbox running, the navigation has
       to be swallowed or the tab leaves the page behind the panel that just
       opened. Capture phase, so it lands before anything else acts on it. */
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[data-fv-zoom-open]');
      if (link) event.preventDefault();
    }, true);

    on(prev, 'click', function () { step(-1); });
    on(next, 'click', function () { step(1); });
    on(document, 'keydown', function (event) {
      if (box.hidden || group.length < 2) return;
      if (event.key === 'ArrowLeft') { event.preventDefault(); step(-1); }
      else if (event.key === 'ArrowRight') { event.preventDefault(); step(1); }
    });
  })();

  makeDialog('[data-fv-spin]', '[data-fv-spin-open]', [
    '[data-fv-spin-close]',
    '[data-fv-spin-scrim]'
  ]);

  makeDialog('[data-fv-offers]', '[data-fv-offers-open]', [
    '[data-fv-offers-close]',
    '[data-fv-offers-scrim]'
  ]);

  /* --------------------------------------------------------------------------
     Variant selection.
     Each option is a link; intercepting it swaps the price, the hidden variant
     id and the URL without a reload. If anything is missing, the link navigates
     normally and the server renders the right page.
     -------------------------------------------------------------------------- */
  (function variants() {
    var picker = $('[data-fv-variants]');
    if (!picker) return;

    /* The finish's photograph, shown by the gallery that is already on the
       page. The gallery used to be replaced with the server's copy, which
       left its own script (thumbnails, swipe, the loading bar, the fade)
       pointing at an image that was no longer there: the new shot snapped in
       with no loading state, and the thumbnails stopped answering. Now the
       hero keeps its element and only changes source — so the fade and the
       loading bar run as for any shot — and on a phone the slider glides to
       that finish's slide. */
    function pathOf(url) {
      try { return new URL(url, window.location.href).pathname; } catch (error) { return url || ''; }
    }
    function showFinishShot(parsed) {
      var nextMain = parsed.querySelector('.fv-gal__main');
      var nextHero = parsed.querySelector('.fv-gal__hero');
      if (!nextMain) return;
      var target = pathOf(nextMain.getAttribute('src'));
      var thumbs = $$('[data-fv-gallery-thumb]');
      var index = -1;
      thumbs.forEach(function (thumb, i) {
        if (index < 0 && pathOf(thumb.dataset.fvFull) === target) index = i;
      });

      var main = $('.fv-gal__main');
      var hero = $('.fv-gal__hero');
      if (main && pathOf(main.getAttribute('src')) !== target) {
        main.classList.add('is-changing');
        if (nextMain.getAttribute('srcset')) main.setAttribute('srcset', nextMain.getAttribute('srcset'));
        else main.removeAttribute('srcset');
        main.src = nextMain.getAttribute('src');
        main.alt = nextMain.getAttribute('alt') || '';
        var settle = function () { main.classList.remove('is-changing'); };
        if (main.complete) window.requestAnimationFrame(settle);
        else main.addEventListener('load', settle, { once: true });
      }
      if (hero && nextHero) {
        if (nextHero.dataset.fvFull) hero.dataset.fvFull = nextHero.dataset.fvFull;
        if (nextHero.dataset.fvAlt) hero.dataset.fvAlt = nextHero.dataset.fvAlt;
      }
      if (index < 0) return;
      thumbs.forEach(function (thumb, i) { thumb.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      var label = $('[data-fv-gallery-label]');
      if (label) {
        var viewLabel = thumbs[index].dataset.fvViewLabel || '';
        label.textContent = viewLabel;
        label.hidden = viewLabel === '';
      }
      var track = $('[data-fv-gal-track]');
      var slides = $$('[data-fv-gal-slide]');
      if (track && track.offsetParent !== null && slides[index]) {
        track.scrollTo({ left: track.scrollLeft + slides[index].getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: reduceMotion && reduceMotion.matches ? 'auto' : 'smooth' });
      }
    }

    var variantField = $('[data-fv-variant-id]');
    var priceHolder = $('[data-fv-price]');

    on(picker, 'click', function (event) {
      var link = event.target.closest('[data-fv-variant]');
      if (!link) return;
      // Let the browser handle modified clicks (new tab, download, …).
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
      event.preventDefault();

      $$('[data-fv-variant]', picker).forEach(function (other) {
        other.removeAttribute('aria-current');
      });
      link.setAttribute('aria-current', 'true');
      /* A sold-out product renders no buy form, so there may be no variant
         field. That used to send the click on as a full page load — the
         blink between finishes — when only the form needed it. */
      variantField = $('[data-fv-variant-id]');
      if (variantField) variantField.value = link.dataset.fvVariant;

      fetch(link.href)
        .then(function (response) {
          if (!response.ok) throw new Error('Variant request failed: ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          [
            '[data-fv-price]',
            '.fv-buy__status',
            '.fv-buybar__prices'
          ].forEach(function (selector) {
            var current = document.querySelector(selector);
            var next = parsed.querySelector(selector);
            if (current && next) current.replaceWith(next);
          });
          showFinishShot(parsed);
          history.replaceState({}, '', link.href);

          /* The pincode panel is NOT in the replaced-selector list above —
             replacing it would tear out a controller mid-check and lose any
             result on screen. But its `data-fv-pincode-lines` carries the
             variant SKU and its paise price, so leaving it alone would quote
             the finish the customer arrived on rather than the one they just
             picked. So the dataset is carried across by hand. */
          var nextPanel = parsed.querySelector('[data-fv-pincode]');
          var livePanel = document.querySelector('[data-fv-pincode]');
          if (nextPanel && livePanel) {
            // A sold-out finish has no delivery window worth quoting, and an
            // available one gets it back. The server already decided which,
            // so follow the markup rather than re-deriving availability here.
            livePanel.hidden = nextPanel.hasAttribute('hidden');
            var nextLines = nextPanel.getAttribute('data-fv-pincode-lines');
            if (nextLines !== null) livePanel.setAttribute('data-fv-pincode-lines', nextLines);
            ['fvStockState', 'fvStockLabel', 'fvStockDetail'].forEach(function (key) {
              if (nextPanel.dataset[key] !== undefined) livePanel.dataset[key] = nextPanel.dataset[key];
            });
          }

          // The replaced status block carries the new variant's availability,
          // so anything that has to hide for a sold-out finish — the Buy now
          // control — can follow without a second request.
          var stock = document.querySelector('[data-fv-stock-state]');
          document.dispatchEvent(
            new CustomEvent('furniva:variant:change', {
              bubbles: true,
              detail: {
                id: Number(link.dataset.fvVariant),
                available: stock ? stock.dataset.fvStockState !== 'soldout' : true
              }
            })
          );
        })
        .catch(function (error) {
          // Fall back to a real navigation so the customer still gets the
          // correct variant page.
          if (window.console && console.warn) console.warn('Finish change fell back to a page load:', error);
          window.location.href = link.href;
        });
    });
  })();

  /* --------------------------------------------------------------------------
     Add to cart.
     Posts to /cart/add so the customer stays on the page. The drawer is NOT
     opened: interrupting someone still reading a product with a panel they did
     not ask for is what the add-to-cart sequence in furniva-addfx.js replaces —
     the photo flies to the cart icon and the count rolls up, which says the
     same thing without taking the page away. On failure the message is explicit
     that nothing was charged and nothing was reserved.
     -------------------------------------------------------------------------- */
  (function addToCart() {
    var form = document.getElementById('fv-product-form');
    var feedback = $('[data-fv-add-feedback]');
    if (!form) return;

    on(form, 'submit', function (event) {
      event.preventDefault();

      var button = form.querySelector('[name="add"]');
      if (window.FurnivaAddFx) window.FurnivaAddFx.working(button);
      else if (button) { button.disabled = true; button.innerHTML = 'Adding…'; }

      var body = new FormData(form);
      var routeRoot =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

      fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: body
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw data;
            return data;
          });
        })
        .then(function (cart) {
          // The status line is the accessible confirmation; the animation is
          // the visible one, and a screen reader hears this without the focus
          // moving anywhere.
          // Success is announced, not displayed. The button's own animation and
          // the bag count are the visible confirmation; a persistent green line
          // under the controls was one more thing to read and to clear.
          // Failures keep their visible line — those the customer must see.
          if (feedback) {
            feedback.className = 'fv-addstate';
            feedback.textContent = '';
            var heard = document.createElement('span');
            heard.className = 'fv-vh';
            heard.textContent = 'Added to cart.';
            feedback.appendChild(heard);
          }
          if (window.FurnivaAddFx) window.FurnivaAddFx.added(button, cart, 'Added to cart');
          else document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function (error) {
          // A failure never borrows the success treatment. Restoring the label
          // is the effects module's job — it is the only thing that knows what
          // the label was before it swapped it out.
          var message =
            (error && error.description) ||
            'We could not add this to your cart. Nothing was charged and nothing was reserved.';
          if (window.FurnivaAddFx) window.FurnivaAddFx.failed(button);
          if (feedback) {
            feedback.textContent = message;
            feedback.className = 'fv-addstate is-error';
          }
        });
    });
  })();

  /* --------------------------------------------------------------------------
     The product photograph, while it is arriving.

     The page's own progress bar covers the navigation to here; once the page is
     up, the largest thing on it is a square of empty media surface for as long
     as the shot takes to decode, and nothing said so. The same bar the cards
     use runs across the top of the frame until there is a picture in it.

     It follows the hero through a thumbnail swap too: changing shot sets a new
     src, which is another wait, and the frame is the right place to say so.
     -------------------------------------------------------------------------- */
  (function galleryLoading() {
    var hero = $('.fv-gal__hero');
    var main = $('.fv-gal__main');
    if (!hero || !main) return;

    function settle() { hero.classList.remove('is-photo-loading'); }
    function watch() {
      if (main.complete && main.naturalWidth) { settle(); return; }
      hero.classList.add('is-photo-loading');
      main.addEventListener('load', settle, { once: true });
      main.addEventListener('error', settle, { once: true });
      // A src that never resolves must not leave the bar running.
      window.setTimeout(settle, 10000);
    }

    watch();
    // furniva.js swaps the hero's src when a thumbnail is pressed; `is-changing`
    // is the class it adds while it does, which makes it the signal to re-arm.
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function (records) {
        records.forEach(function (record) {
          if (record.attributeName === 'src') watch();
        });
      }).observe(main, { attributes: true, attributeFilter: ['src'] });
    }

    // The thumbnails below it get the same treatment.
    $$('.fv-gal__tile').forEach(function (tile) {
      var image = tile.querySelector('img');
      if (!image || image.complete) return;
      tile.classList.add('is-photo-loading');
      var done = function () { tile.classList.remove('is-photo-loading'); };
      image.addEventListener('load', done, { once: true });
      image.addEventListener('error', done, { once: true });
      window.setTimeout(done, 10000);
    });
  })();

  /* --------------------------------------------------------------------------
     Pinch to magnify, out of the page.

     A touchscreen has no pointer to follow, so the gesture is the input. Scaling
     the image where it sits does not work: the frame clips it, so the picture
     can never grow past the box it is already in — which is the whole reason for
     pinching it.

     So the shot lifts out. A copy of it is placed over the page at exactly the
     rect the original occupies, on a backdrop that darkens as the fingers
     spread, and it is that copy which scales — up to 1.8x, following the centre
     of the gesture across the screen. Let go and it animates back into its own
     frame and is removed. The original never moves, so nothing below it reflows.

     The move handler is NOT passive and calls preventDefault, because otherwise
     the browser takes the second finger and zooms the whole document instead. A
     single finger is left entirely alone, so scrolling past the gallery works as
     it always did — that is what `touch-action: pan-y` on the frame buys.

     Opt in with data-fv-pinchzoom on the frame; its value is the ceiling.
     -------------------------------------------------------------------------- */
  (function pinchZoom() {
    // Phones only, like the double tap in the slider.
    var phoneWidth = window.matchMedia('(max-width: 759.98px)');
    $$('[data-fv-pinchzoom]').forEach(function (frame) {
      var image = frame.querySelector('img');
      if (!image) return;
      var ceiling = parseFloat(frame.dataset.fvPinchzoom) || 1.8;

      var startGap = 0;
      var startCentre = null;
      var from = null;
      var lift = null;
      var backdrop = null;
      var flying = null;

      function gap(touches) {
        var dx = touches[0].clientX - touches[1].clientX;
        var dy = touches[0].clientY - touches[1].clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }
      function midpoint(touches) {
        return {
          x: (touches[0].clientX + touches[1].clientX) / 2,
          y: (touches[0].clientY + touches[1].clientY) / 2
        };
      }

      function build(touches) {
        from = image.getBoundingClientRect();
        if (!from.width || !from.height) return false;

        backdrop = document.createElement('div');
        backdrop.className = 'fv-pinch__backdrop';
        backdrop.setAttribute('aria-hidden', 'true');

        flying = image.cloneNode(true);
        flying.className = 'fv-pinch__img';
        flying.removeAttribute('loading');
        flying.setAttribute('aria-hidden', 'true');

        lift = document.createElement('div');
        lift.className = 'fv-pinch';
        lift.setAttribute('aria-hidden', 'true');
        lift.style.left = from.left + 'px';
        lift.style.top = from.top + 'px';
        lift.style.width = from.width + 'px';
        lift.style.height = from.height + 'px';
        lift.appendChild(flying);

        document.body.appendChild(backdrop);
        document.body.appendChild(lift);
        // Next frame, so the backdrop has a state to transition from.
        window.requestAnimationFrame(function () {
          if (backdrop) backdrop.classList.add('is-on');
        });
        return true;
      }

      function teardown() {
        var goneLift = lift;
        var goneBack = backdrop;
        lift = null;
        backdrop = null;
        flying = null;
        from = null;
        startGap = 0;
        startCentre = null;
        if (!goneLift) return;

        goneLift.classList.add('is-settling');
        goneLift.style.transform = '';
        if (goneBack) goneBack.classList.remove('is-on');

        var remove = function () {
          if (goneLift && goneLift.parentNode) goneLift.parentNode.removeChild(goneLift);
          if (goneBack && goneBack.parentNode) goneBack.parentNode.removeChild(goneBack);
        };
        if (reduceMotion.matches) remove();
        else window.setTimeout(remove, 260);
      }

      frame.addEventListener('touchstart', function (event) {
        if (event.touches.length !== 2 || lift || frame.classList.contains('is-zoomed') || !phoneWidth.matches) return;
        startGap = gap(event.touches);
        startCentre = midpoint(event.touches);
        if (!build(event.touches)) { startGap = 0; startCentre = null; }
      }, { passive: true });

      frame.addEventListener('touchmove', function (event) {
        if (!lift || event.touches.length !== 2 || startGap <= 0) return;
        event.preventDefault();

        // Between 1x and the ceiling, in proportion to how far the fingers have
        // spread. Pinching back in returns it rather than sticking at the top.
        var scale = Math.max(1, Math.min(ceiling, gap(event.touches) / startGap));
        var now = midpoint(event.touches);
        // Centre the lifted shot on the viewport as it grows, and let the
        // fingers carry it from there, so a corner of the picture can be brought
        // into the middle of the screen to look at.
        var reach = (scale - 1) / (ceiling - 1);
        var toCentreX = (window.innerWidth / 2 - (from.left + from.width / 2)) * reach;
        var toCentreY = (window.innerHeight / 2 - (from.top + from.height / 2)) * reach;
        var dragX = now.x - startCentre.x;
        var dragY = now.y - startCentre.y;

        lift.style.transform =
          'translate3d(' + (toCentreX + dragX) + 'px,' + (toCentreY + dragY) + 'px,0) scale(' + scale + ')';
        if (backdrop) backdrop.style.opacity = String(Math.min(1, reach));
      }, { passive: false });

      frame.addEventListener('touchend', function (event) {
        if (event.touches.length < 2) teardown();
      }, { passive: true });
      frame.addEventListener('touchcancel', teardown, { passive: true });
    });
  })();

  /* Minimal assembly resources dialog. */
  (function assemblyResources() {
    var modal = $('[data-fv-assembly-modal]');
    var openButton = $('[data-fv-assembly-open]');
    if (!modal || !openButton) return;
    var closeButtons = $$('[data-fv-assembly-close]', modal);
    var isOpen = false;
    function open() {
      isOpen = true;
      modal.hidden = false;
      window.requestAnimationFrame(function () {
        if (isOpen) modal.classList.add('is-open');
      });
      document.body.style.overflow = 'hidden';
      var focus = $('[data-fv-assembly-close]', modal);
      if (focus) focus.focus({ preventScroll: true });
    }
    function close() {
      isOpen = false;
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      openButton.focus({ preventScroll: true });
      if (reduceMotion.matches) modal.hidden = true;
      else window.setTimeout(function () {
        if (!modal.classList.contains('is-open')) modal.hidden = true;
      }, 420);
    }
    on(openButton, 'click', open);
    closeButtons.forEach(function (button) { on(button, 'click', close); });
    on(document, 'keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) close();
    });
  })();

  on($('[data-fv-size-link]'), 'click', function () {
    // The sections below the buy area are closed panels now; the one the
    // size link points at opens on the way there.
    var panel = document.querySelector('[data-fv-pdpacc="fv-dimensions"]');
    if (panel) panel.open = true;
    window.setTimeout(function () {
      var target = document.getElementById('fv-dimensions');
      if (target) target.focus({ preventScroll: true });
    }, reduceMotion.matches ? 0 : 420);
  });

  /* --------------------------------------------------------------------------
     Pincode check — moved to assets/furniva-pincode.js.

     The snippet renders on the product page AND on the cart, but this file is
     loaded only by the product section, so the cart's Check button had no
     handler at all. The controller now ships with the snippet, which is the
     only place that knows it is on the page.
     -------------------------------------------------------------------------- */

  /* --------------------------------------------------------------------------
     Dimensions: cm / in switch.
     Centimetres are what the metafields hold and what the page prints. The
     switch re-labels the figures in inches and puts the printed text back when
     switched off. Placement notes are free text, so any "NN cm" inside them is
     converted in place. The choice is remembered across products.
     -------------------------------------------------------------------------- */
  (function () {
    var box = $('[data-fv-units]');
    var toggle = box && $('.fv-units', box);
    if (!toggle) return;

    var KEY = 'fv-units';
    var CM_IN_TEXT = /(\d+(?:\.\d+)?)\s*cm\b/g;
    var figures = $$('[data-fv-cm]', box);
    var notes = $$('.fv-dims__note > span', box).filter(function (el) {
      return !el.querySelector('[data-fv-cm]') && /\d\s*cm\b/.test(el.textContent);
    });
    figures.forEach(function (el) { el.setAttribute('data-fv-cm-text', el.textContent); });
    notes.forEach(function (el) { el.setAttribute('data-fv-cm-text', el.textContent); });

    function inches(cm) {
      var value = Math.round((parseFloat(cm) / 2.54) * 10) / 10;
      return String(value).replace(/\.0$/, '') + ' in';
    }

    function apply(unit) {
      var toInches = unit === 'in';
      figures.forEach(function (el) {
        el.textContent = toInches ? inches(el.getAttribute('data-fv-cm')) : el.getAttribute('data-fv-cm-text');
      });
      notes.forEach(function (el) {
        var text = el.getAttribute('data-fv-cm-text');
        el.textContent = toInches ? text.replace(CM_IN_TEXT, function (m, cm) { return inches(cm); }) : text;
      });
      $$('[data-fv-unit]', toggle).forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-fv-unit') === unit ? 'true' : 'false');
      });
    }

    $$('[data-fv-unit]', toggle).forEach(function (btn) {
      on(btn, 'click', function () {
        var unit = btn.getAttribute('data-fv-unit');
        apply(unit);
        try { localStorage.setItem(KEY, unit); } catch (e) {}
      });
    });

    var saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) {}
    toggle.hidden = false;
    if (saved === 'in') apply('in');
  })();

})();
